// extracted by mini-css-extract-plugin
module.exports = {"Header":"SubCategoryPage_Header__3ZAjc","SubCat":"SubCategoryPage_SubCat__1LBpw"};